import { TenantActionTypes, TenantActions } from './tenant.actions';
import { TENANT_INITIAL_STATE, TenantState } from './tenant.state';

export function tenantReducer(
  state: TenantState = TENANT_INITIAL_STATE,
  action: TenantActions,
): TenantState {
  switch (action.type) {
    case TenantActionTypes.INITIALISE: {
      return { ...state, tenant: action.payload };
    }

    default: {
      return state;
    }
  }
}
